import { Tooltip as MuiTooltip } from '@mui/material';
import { useTheme } from './hooks';
import type { SxProps, Theme } from '@mui/material/styles';
import type { TooltipOwnerState, TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

export type TooltipProps = MuiTooltipProps;

export const Tooltip = ({ slotProps, ...rest }: TooltipProps): JSX.Element => {
  const theme = useTheme();
  const baseTooltipSx: SxProps<Theme> = {
    backgroundColor: theme.app.colors.surface,
    border: `1px solid ${theme.app.colors.border}`,
    color: theme.app.colors.text,
  };
  const tooltipSlot = slotProps?.tooltip;
  const arrowSlot = slotProps?.arrow;
  const baseArrowSx: SxProps<Theme> = {
    color: theme.app.colors.surface,
    '&::before': {
      border: `1px solid ${theme.app.colors.border}`,
      boxSizing: 'border-box',
    },
  };
  const resolveTooltipSlot = (
    ownerState: TooltipOwnerState,
  ): NonNullable<TooltipProps['slotProps']>['tooltip'] => {
    const resolved = typeof tooltipSlot === 'function' ? tooltipSlot(ownerState) : tooltipSlot;
    const resolvedSx = resolved?.sx;
    const mergedSx = resolvedSx
      ? [baseTooltipSx, ...(Array.isArray(resolvedSx) ? resolvedSx : [resolvedSx])]
      : baseTooltipSx;
    return {
      ...(resolved ?? {}),
      sx: mergedSx as SxProps<Theme>,
    };
  };
  const resolveArrowSlot = (
    ownerState: TooltipOwnerState,
  ): NonNullable<TooltipProps['slotProps']>['arrow'] => {
    const resolved = typeof arrowSlot === 'function' ? arrowSlot(ownerState) : arrowSlot;
    const resolvedSx = resolved?.sx;
    const mergedSx = resolvedSx
      ? [baseArrowSx, ...(Array.isArray(resolvedSx) ? resolvedSx : [resolvedSx])]
      : baseArrowSx;
    return {
      ...(resolved ?? {}),
      sx: mergedSx as SxProps<Theme>,
    };
  };
  return (
    <MuiTooltip
      {...rest}
      slotProps={{
        ...slotProps,
        tooltip: resolveTooltipSlot,
        arrow: resolveArrowSlot,
      }}
    />
  );
};
